import React, { ReactElement, useEffect } from 'react';
import { Column, Grid, Row, Button, ButtonSet } from 'carbon-components-react';

import { FormattedMessage } from 'react-intl';
import { scrollTo } from 'src/common/utils/smoothScroll';
import { segmentTracking } from '../lib/tracker';
import messages from '../locales/messages';
import './RPAROIEstimator.scss';
import ThanksDetails from './ThanksDetails';

export interface thanksProps {
  numberOfProcessToAutomate: number;
  currentNumberOfHoursPerWeek: number;
  currentFullTimeEmployeeCost: number;
  roiValue: string;
  errorRate: number;
  bpName: string;
  bpConsentMail: boolean;
}

const Thanks = ({
  numberOfProcessToAutomate: numberOfProcessToAutomate,
  currentNumberOfHoursPerWeek: currentNumberOfHoursPerWeek,
  currentFullTimeEmployeeCost: currentFullTimeEmployeeCost,
  roiValue: roiValue,
  errorRate: errorRate,
}: thanksProps): ReactElement => {
  useEffect(() => {
    scrollTo('ThankYou');
  }, []);
  return (
    <Grid id="ThankYou">
      <Row>
        <Column sm={4} md={8} lg={12}>
          <div className="bx--row padding-row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-16">
              <div className="thanks__pad1 page_heading">
                <FormattedMessage {...messages.thankYouTitle} />
              </div>
              <div className="page_sub_heading">
                <FormattedMessage {...messages.thankYouSubTitle} />
              </div>
              <div className="page_sub_heading_2 thanks__pad2">
                <FormattedMessage {...messages.thankYouDetailsTitle} />
              </div>
              <div className="thanks__requirement thanks__pad4">
                <ThanksDetails
                  currentNumberOfHoursPerWeek={currentNumberOfHoursPerWeek}
                  currentFullTimeEmployeeCost={currentFullTimeEmployeeCost}
                  errorRate={errorRate}
                  numberOfProcessToAutomate={numberOfProcessToAutomate}
                  roiValue={roiValue}
                ></ThanksDetails>
              </div>
              <ButtonSet className="RPA_ROI__stack-button thanks__pad3" stacked>
                <Button
                  onClick={() => {
                    segmentTracking('CTA Clicked', {
                      pageTitle: 'RPA Pricing Page',
                      object: 'Pricing page',
                      resultValue: 'CTA clicked',
                      CTA: 'Return to Estimator',
                      location: 'Thankyou',
                      action: '',
                      field: '',
                    });
                    window.location.reload();
                  }}
                >
                  <FormattedMessage {...messages.returnToEstimator} />
                </Button>
              </ButtonSet>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
};

export default Thanks;
